<template>
	<div style="min-height: 100vh;">
		<div style="text-align: center;">
		    <div class="panel">
		        <div class="panel-header" style="display: flex;justify-content: space-between;">
		            <div>
		                {{ main.StoreName }} (<span v-if="main.Deadline>0">{{ $t('message.remainingDays', { days: main.Deadline }) }}</span>
		                <span v-else>{{ $t('message.remainingTimes', { times: main.Remainingtimes }) }}</span>)
		            </div>                    
		        </div>
		        <div class="panel-body" style="min-height: 400px;">
		            <div style="text-align: left;">
		                <button class="btn btn-success" @click="jref('/khe?id=0')">{{ $t('message.newCustomer') }}</button>          
		            </div>
		            <table class="table table-border table-bordered table-hover table-bg table-sort" style="margin-top: 20px;">
		                <thead>
		                    <tr class="text-c">                                
		                        <th>{{ $t('message.name') }}</th>
		                        <th>{{ $t('message.gender') }}</th>
		                        <th>{{ $t('message.age') }}</th>
		                        <th>{{ $t('message.contact') }}</th>
		                        <th>{{ $t('message.fitter') }}</th>
		                        <th>{{ $t('message.date') }}</th>                                
		                        <th>{{ $t('message.fittingRecords') }}</th>
		                        <th>{{ $t('message.editInfo') }}</th>
								<th>{{ $t('message.del') }}</th>
		                    </tr>
		                </thead>
		                <tbody>
		                    <tr class="text-c" v-for="(item, index) in list" :key="index">
		                        <td>{{ item.name }}</td>
		                        <td>{{ item.Gender }}</td>
		                        <td>{{ item.Age }}</td>
		                        <td>{{ item.Contactinformation }}</td>
		                        <td>{{ item.fitter }}</td>
		                        <td>{{ item.date }}</td>                                
		                        <td class="td-manage">                                    
		                            <button class="btn btn-success" @click="jref('/flist?id='+item.id)">{{ $t('message.viewCreate') }}</button>                                    
		                        </td>
		                        <td class="td-manage">                                    
		                            <button class="btn btn-primary" @click="jref('/khe?id='+item.id)">{{ $t('message.editInfo') }}</button>                                    
		                        </td>
								<td class="td-manage">
								    <button class="btn btn-warning" @click="del(item.id)">{{ $t('message.del') }}</button>                                    
								</td>
		                    </tr>                            
		                </tbody>
		            </table>
		        </div>
		    </div>
		    <div style="display: flex;justify-content: start;padding-top: 10px;background-color: #fff;padding-bottom: 10px;">
		        <div style="flex: 2;text-align: left;padding-left: 20px;">
		            <img src="https://bike.typhcl.cn/md/imgs/inv_md.jpg" style="height: 400px;width: 800px;" />
		        </div>
		        <div style="flex: 2;text-align: left;padding-left: 20px;">
		            <img src="https://bike.typhcl.cn/md/imgs/con.jpg" style="height: 400px;width: 800px;" />
		        </div>
		    </div>
		    <div style="position: absolute;right: 20px;top: 10px;">
		        {{ $t('message.switchLanguage') }}:
		        <button style="padding: 3px;background-color: #fff;color: #000;border-radius: 2px;border: 1px solid #000;margin-left: 10px;" 
		            @click="switchLanguage">
		            {{ $t('message.language') }}
		        </button>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				// 在这里定义你的组件数据
				src: "",
				list: [],
				main: {
					Deadline: 0,
					Remainingtimes: 0
				}
			};
		},
		computed: {
			// 计算属性
		},
		methods: {
			del(id){
				var that=this
				if(confirm("确认删除?")){
					$.ajax({
						url: that.URL,
						data: {
							t: "del_kh",
							token: localStorage.getItem('token'),
							id:id
						},
						dataType: "json",
						success(e) {
							$.ajax({
								url: that.URL,
								data: {
									t: "md_kh",
									token: localStorage.getItem('token')
								},
								dataType: "json",
								success(e) {								
									that.list = e.list;
								}
							})
						}
					})
				}
				
			},
			// 方法
			switchLanguage() {
				const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
				this.$i18n.locale = newLang;
				localStorage.setItem('lang', newLang); // 记住用户选择的语言
			},
			init() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "msg_init",
						token: localStorage.getItem('token')
					},
					dataType: "json",
					success(e) {
						if (e.pid == 0) {
							that.$router.replace('/login');
						}
						that.$data.main = e.main;
					}
				})
				$.ajax({
					url: that.URL,
					data: {
						t: "md_kh",
						token: localStorage.getItem('token')
					},
					dataType: "json",
					success(e) {
						if (e.pid == 0) {
							that.$router.replace('/login');
						}
						that.list = e.list;
					}
				})
			}
		},
		mounted() {
			var that = this
			// 组件挂载后执行的代码
			that.init()
		}
	}
</script>

<style>
	.row {
		margin-top: 20px;
	}
</style>